import { createContext } from 'react';
import { ETheme } from './types';
import Styles from '../styles';

export const ThemeContext = createContext({
  theme: ETheme.dark,
  setTheme: (value: ETheme) => {},
  styles: Styles(ETheme.dark)
});